import React, { useEffect } from "react";
import { Row, Col, CardBody, Card, Alert, Container, Input, Label, Form, FormFeedback } from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { registerUser, apiError, resetRegisterFlag } from "../../slices/thunks";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import logo from "../../assets/images/friel-logo.png";
import { createSelector } from "reselect";

const commonPasswords = [
    "123456", "password", "123456789", "12345678", "12345", "1234567", "qwerty",
    "abc123", "password1", "111111"
  ];

const Register = () => {
    const history = useNavigate();
    const dispatch = useDispatch();


    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            email: '',
            username: '',
            password1: '',
            password2: ''
        },
        validationSchema: Yup.object({
            email: Yup.string()
            .email("Please enter a valid email")
            .matches(
              /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/,
              "Email must be valid"
            )
            .required("Please enter email"),
            username: Yup.string()
                .matches(
                    /^[a-zA-Z0-9@.+-_]+$/,
                    "Enter a valid username. This value may contain only letters, numbers, and @/./+/-/_ characters."
                )
                .required("Please Enter Your Username"),
            password1: Yup.string()
              .required("Please enter your Password")
              .min(8, "Password must be at least 8 characters long")
              .matches(/^(?=.*[0-9])(?=.*[A-Za-z]).*$/, "Password must contain both letters and numbers")
              .test(
                "attribute-similarity",
                "Password is too similar to your username or email",
                function (value) {
                  const { username, email } = this.parent;
                  return (
                    value &&
                    !(
                      username && value.includes(username) ||
                      email && value.includes(email.split("@")[0])
                    )
                  );
                }
              )
              .notOneOf(
                commonPasswords,
                "Password is too common"
              )
              .test(
                "numeric-password",
                "Password must not be entirely numeric",
                (value) => value && !/^\d+$/.test(value)
              ),
            password2: Yup.string()
              .oneOf([Yup.ref("password1")], "Passwords do not match")
              .required("Please confirm your password"),
        }),
        onSubmit: (values) => {
            // dispatch(registerUser(values));
        },
    });

    const selectLayoutState = (state) => state.Account;
    const registerdatatype = createSelector(
        selectLayoutState,
        (account) => ({
            success: account.success,
            error: account.error,
            message: account.registrationError
        })
    );

    const {
        error, success, message
    } = useSelector(registerdatatype);

    useEffect(() => {
        dispatch(apiError(""));
    }, [dispatch]);

    useEffect(() => {
        if (success) {
            toast.success("Registration successful! Redirecting to login page...", { position: "top-right", autoClose: 3000 });
            setTimeout(() => history("/login"), 3500);
        }

        if (error) {
            toast.error(error.message || "Registration failed. Please try again.", { position: "top-right", autoClose: 3000 });
        }

        // setTimeout(() => {
        //     dispatch(resetRegisterFlag());
        // }, 4000);
    }, [dispatch, success, error, history]);

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4 text-white-50">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={logo} alt="" height="150" />
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4">

                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">Create New Account</h5>
                                        </div>
                                        <div className="p-2 mt-4">
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                                className="needs-validation" action="#">

                                                {error && message && (
                                                    <Alert color="danger" fade={false}>  {/* Add fade={false} */}
                                                        {message}
                                                    </Alert>
                                                )}

                                                <div className="mb-3">
                                                    <Label htmlFor="useremail" className="form-label">Email <span className="text-danger">*</span></Label>
                                                    <Input
                                                        id="email"
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="Enter email address"
                                                        type="email"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={
                                                            !!(validation.touched.email && validation.errors.email)
                                                        }
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
                                                    ) : null}

                                                </div>
                                                <div className="mb-3">
                                                    <Label htmlFor="username" className="form-label">Username <span className="text-danger">*</span></Label>
                                                    <Input
                                                        name="username"
                                                        type="text"
                                                        placeholder="Enter username"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.username || ""}
                                                        invalid={
                                                            !!(validation.touched.username && validation.errors.username)
                                                        }
                                                    />
                                                    {validation.touched.username && validation.errors.username ? (
                                                        <FormFeedback type="invalid"><div>{validation.errors.username}</div></FormFeedback>
                                                    ) : null}

                                                </div>

                                                <div className="mb-3">
                                                    <Label htmlFor="userpassword" className="form-label">Password <span className="text-danger">*</span></Label>
                                                    <Input
                                                        name="password1"
                                                        type="password"
                                                        placeholder="Enter Password"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.password1 || ""}
                                                        invalid={
                                                            !!(validation.touched.password1 && validation.errors.password1)
                                                        }
                                                    />
                                                    {validation.touched.password1 && validation.errors.password1 ? (
                                                        <FormFeedback type="invalid"><div>{validation.errors.password1}</div></FormFeedback>
                                                    ) : null}

                                                </div>

                                                <div className="mb-2">
                                                    <Label htmlFor="confirmPassword" className="form-label">Confirm Password <span className="text-danger">*</span></Label>
                                                    <Input
                                                        name="password2"
                                                        type="password"
                                                        placeholder="Confirm Password"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.password2 || ""}
                                                        invalid={
                                                            !!(validation.touched.password2 && validation.errors.password2)
                                                        }
                                                    />
                                                    {validation.touched.password2 && validation.errors.password2 ? (
                                                        <FormFeedback type="invalid"><div>{validation.errors.password2}</div></FormFeedback>
                                                    ) : null}

                                                </div>
                                                <div className="mt-4">
                                                    <button className="btn btn-success w-100" type="submit">Sign Up</button>
                                                </div>

                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>
                                <div className="mt-4 text-center">
                                    <p className="mb-0">Already have an account ? <Link to="/login" className="fw-semibold text-primary text-decoration-underline"> LogIn </Link> </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
            <ToastContainer/>
        </React.Fragment>

    );
};

export default Register;
